<div class="page-container">
  <app-smart-table
    [config]="smartTableConfig"
    [data]="tableData"
    (itemOrNewClicked)="openDialog($event)"
    (deleteClicked)="deleteItem($event)"
  ></app-smart-table>
</div>
